import { render, staticRenderFns } from "./saidas_por_classe.vue?vue&type=template&id=d8b07fdc&"
import script from "./saidas_por_classe.vue?vue&type=script&lang=js&"
export * from "./saidas_por_classe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports